import { vec3 } from "gl-matrix";

/** Applied to every DOM node that is part of the stamp context-menu system.
 * The outside-click handler in Stamp uses this to distinguish the stamp's
 * own menus (main + submenus) from any other MUI popover on the page. */
export const STAMP_MENU_PAPER_PROPS = { "data-stamp-menu": "true" } as const;

export const axis = [
    vec3.fromValues(1, 0, 0),
    vec3.fromValues(0, 1, 0),
    vec3.fromValues(0, 0, 1),
    vec3.fromValues(1, 0, 0),
    vec3.fromValues(0, 1, 0),
    vec3.fromValues(0, 0, 1),
];
export const xAxis = vec3.fromValues(1, 0, 0);
export const yAxis = vec3.fromValues(0, 1, 0);
export const MAX_FLOAT = 3.4028234663852886e38;
